<div class="user-info-container">
    <div class="user-info-block" *ngIf="showCrmInfo && searchResult?.tenantRequests">
        <div class="df gap5 jc-s ai-c">
            <b>Заявки на додавання до приміщення:</b>
            <b>{{searchResult?.tenantRequests?.length}}</b>
        </div>
        <mat-divider></mat-divider>
        <div *ngFor="let tenantRequest of searchResult?.tenantRequests">
            <span class="clickable"  (click)="getAssociation(tenantRequest.association?.id)">
                <b>{{tenantRequest.association?.name}}</b>
                - {{tenantRequest.apartment?.name}}
            </span>
        </div>
    </div>
    <div class="user-info-block" *ngIf="showCrmInfo && searchResult?.tasks">
        <div class="df gap5 jc-s ai-c">
            <b>Заплановані завдання:</b>
            <b>{{searchResult?.tasks?.length}}</b>
        </div>
        <mat-divider></mat-divider>
        <div *ngFor="let task of searchResult?.tasks">
            <span class="clickable" (click)="openCrmItem('TASK', task.id!)">{{'modules.crm.leads.taskTypes.' + task.type | translate}}</span>
        </div>
    </div>
    <div class="user-info-block" *ngIf="showCrmInfo && searchResult?.projects">
        <div class="df gap5 jc-s ai-c">
            <b>Повʼязаня проекти:</b>
            <b>{{searchResult?.projects?.length}}</b>
        </div>
        <mat-divider></mat-divider>
        <div *ngFor="let project of searchResult?.projects">
            <span class="clickable" (click)="openCrmItem('PROJECT', project.id!)">{{project.name}}</span>
        </div>
    </div>
    <div class="user-info-block" *ngIf="searchResult?.government">
        <div class="df gap5 jc-s ai-c">
            <b>Доступ до кабінету управління:</b>
            <b>{{searchResult?.government?.length}}</b>
        </div>
        <mat-divider></mat-divider>
        <div *ngFor="let admin of searchResult?.government" class="clickable" (click)="getAssociation(admin.association?.id)">
            <b>{{admin.association?.name}}</b>
            - {{admin?.position ? admin.position + ',' : ''}} {{admin?.role ? admin.role : ''}}
        </div>
    </div>
    <div class="user-info-block" *ngIf="searchResult?.tenants">
        <div class="df gap5 jc-s ai-c">
            <b>У реєстрі користувачів:</b>
            <b>{{searchResult?.tenants?.length}}</b>
        </div>
        <mat-divider></mat-divider>
        <div *ngFor="let apartment of searchResult?.tenants" class="clickable df-c gap5" [ngClass]="{'warning': !apartment.hasAccess}"
             (click)="getAssociation(apartment.association?.id)">
            <div>
                <b>{{apartment.association?.name}}</b>
                - {{apartment.apartment?.name}} {{!apartment.hasAccess ? 'Доступ в Дах не надано' : ''}}
                <b *ngIf="apartment?.role">
                    {{'common.role.' + apartment.role!.toLowerCase() | translate}}
                </b>
            </div>
            <div *ngFor="let manager of apartment?.managers" [ngClass]="{'mine': currentUser?.id && manager.manager?.id && currentUser?.id == manager.manager?.id}">
                {{manager.manager?.name}} - {{'modules.references.administrators.positions.' + manager.position | translate}}
            </div>
        </div>
    </div>
</div>
